import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { LeadTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/lead.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = () => {
    const event: AnalyticsEvent<LeadTrackingInfo> = {
        event: EventType.Lead,
        payload: {
            eventData: {}
        }
    };

    TrackingService.track(event);
};
